import React from "react";

const ThemeButtom = (props) => {
  return <button onClick={props.handleClick} className="theme-btn">{props.title}</button>;
};

export default ThemeButtom;
